import { useEffect } from 'react';
import { r7DesktopConfig } from 'reactApp/appHelpers/featuresHelpers/features/r7DesktopApp';
interface UserInfo {
    email: string;
    userId: string;
}

const getR7DesktopConfig = () => {
    return {
        displayName: r7DesktopConfig?.displayName ?? null,
        provider: r7DesktopConfig?.provider ?? null,
        domain: r7DesktopConfig?.domain ?? null,
    };
};

const isDesktopR7App = window && !!((window as any).AscDesktopEditor && typeof (window as any).AscDesktopEditor.execCommand === 'function');

export const runDesktopR7Script = (params: UserInfo) => {
    if (!isDesktopR7App) {
        return;
    }

    const config = getR7DesktopConfig();

    (window as any).AscDesktopEditor.execCommand('portal:login', JSON.stringify({ ...config, ...params }));
};

// Костыль, т.к. внутри Page@desktop.tsx делать это через проверку на window не выйдет, т.к. SSR
// Приходится после маунта компонента сразу скрывать
export const hideHeadlineForDesktopR7 = () => {
    if (!isDesktopR7App) {
        return;
    }

    const headline = document.querySelector('#headline') as HTMLElement;

    if (headline) {
        headline.style.display = 'none';
    }
};

export const useDesktopR7App = () => {
    useEffect(() => {
        if (isDesktopR7App) {
            document.cookie = '_r7desktop=1; Max-Age=31536000; Path=/; Secure; SameSite=Lax';
        }
    }, []);
};
